module.exports = __webpack_public_path__ + "media/images/icons/logo-50b621757d09f4b9e4ea127f726bb45e.svg";